import React, { useCallback } from 'react'
import { TravelExploreOutlined } from '@mui/icons-material'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'
import paths from '@app/src/wf-constants/paths'
import ErrorPage from './base'

const NotFoundPage: React.FC = () => {
  const { formatMessage } = useIntl()
  const history = useHistory()

  const handleGoHome = useCallback(() => {
    history.push(paths.dashboard)
  }, [history])

  return (
    <ErrorPage
      title={formatMessage({ id: 'errors.404.title' })}
      description={formatMessage({
        id: 'errors.404.message',
      })}
      buttonText={formatMessage({ id: 'errors.goHome' })}
      onButtonClick={handleGoHome}
      iconComponent={TravelExploreOutlined}
      testId="page-404"
      buttonTestId="go-home-button"
    />
  )
}

export default NotFoundPage
